import {
  RESET_ADITIONAL_FIELDS,
  ADITIONAL_FIELDS_ERROR,
  GET_ADITIONAL_FIELDS,
  SET_ADITIONAL_FIELDS,
  SET_CURRENT_CHAT_DATA,
  SAVE_ADITIONAL_FIELDS,
  SAVE_ADITIONAL_FIELDS_SUCCESS,
  RESET_API_ADITIONAL_FIELDS,
} from "./actionTypes";

const initialState = {
  currentChatId: "",
  currentConsumerId: "",
  currentConversationTabId: "",
  data: {},
  info: {},
  status: {},
};

const AditionalFields = (state = initialState, action) => {
  switch (action.type) {
    case ADITIONAL_FIELDS_ERROR:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.action]: {
            error: {
              status: true,
              message: action.payload.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case RESET_ADITIONAL_FIELDS:      
      delete state.info[action.payload];      
      break;
    case RESET_API_ADITIONAL_FIELDS:      
      state = {
        ...state,
        status: {
          ...state.status,
          save_fields: {
            error: false,
            loading: false,
            success: false,
          },
        },
      }; 
      break;
    case GET_ADITIONAL_FIELDS:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state.status,
          get_info: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SET_ADITIONAL_FIELDS:
      state = {
        ...state,
        data: null,
        info: {
          ...(state.info ? state.info : null),
          [action.payload.chatId]: action.payload.data,
        },
        status: {
          ...state.status,
          get_info: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    case SET_CURRENT_CHAT_DATA:
      state = {
        ...state,
        currentConversationId: action?.payload?.conversationId,
        currentTabId: action?.payload?.tabId,
        currentConsumerId: action?.payload?.consumerId,
      };
      break;
    case SAVE_ADITIONAL_FIELDS:
      state = {
        ...state,
        data: null,
        status: {
          ...state.status,
          save_fields: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case SAVE_ADITIONAL_FIELDS_SUCCESS:
      state = {
        ...state,
        data: null,
        info: {
          ...(state.info ? state.info : null),
          [action.payload.chatId]: action.payload.data,
        },
        status: {
          ...state.status,
          save_fields: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default AditionalFields;
